import * as React from "react";
import {usePriceQuery} from "../../../hooks/usePriceQuery";

export const PriceBox = () => {
    const {
        model: {
            onSale,
            minimumOrderQuantity,
            hasMinimumOrderQuantityRequirement,
            formatted: {
                startingPrice,
                currentPrice,
                unitPrice,
                saleAmount,
                salePercentage,
                unitOfMeasure
            }
        },
        error
    } = usePriceQuery();

    if (error) {
        return (
            <div className="d-md-block d-lg-flex align-items-center">
                <div style={{fontSize: '2rem'}}></div>
            </div>
        )
    }

    return (
       <div className="d-flex flex-column">
        <div className="d-md-block d-lg-flex align-items-center ">
            <div style={{fontSize: '2rem', height: '2.5rem'}}>
                {currentPrice}{' '} 
            </div>
            {onSale && (
                <div className="ms-2" style={{fontSize: '0.8rem'}}>
                    <span className="text-muted" style={{textDecoration: 'line-through'}}>
                        {unitPrice}
                    </span>
                    {(saleAmount && salePercentage) && (
                        <span className="text-danger d-block">
                            Save {salePercentage}%
                        </span>
                    )}  
                </div>
            )}
        </div>
        <div>
        {hasMinimumOrderQuantityRequirement && (
                    <span className="text-muted" style={{fontSize: '0.8rem'}}>
                      Starting at {startingPrice} for {minimumOrderQuantity} {unitOfMeasure}
                    </span>
                )}
        </div>
        </div>
    )
}